import { configure, Field as VeeField } from 'vee-validate'
import { registerRules } from './rules'
import VeeFormWrapper from './VeeFormWrapper.vue'
import VeeFieldClassesDirective from '@/base/directives/veeFieldClasses.directive'

export function setupVeeValidate(app) {
  registerRules()

  configure({
    validateOnInput: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnModelUpdate: true,
  })

  app.component('VeeFormWrapper', VeeFormWrapper)
  app.component('VeeField', VeeField)

  app.directive('field-classes', VeeFieldClassesDirective)
}
